import { render, staticRenderFns } from "./CourseCategory.vue?vue&type=template&id=76cbae3c&scoped=true"
import script from "./CourseCategory.vue?vue&type=script&lang=js"
export * from "./CourseCategory.vue?vue&type=script&lang=js"
import style0 from "./CourseCategory.vue?vue&type=style&index=0&id=76cbae3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cbae3c",
  null
  
)

export default component.exports